import React from 'react'
import { Link } from 'react-router-dom'

import PerfectScrollbar from 'react-perfect-scrollbar'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import TablePagination from '@material-ui/core/TablePagination'
import Skeleton from '@material-ui/lab/Skeleton'

import { routes } from 'routes'
import { Container, ContentHeader, TableHeader, Filters } from 'components'
import { Permitted } from 'components/Permissions'
import * as service from 'service'
import PlansTable from './components/PlansTable'
import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import useFilter from 'hooks/useFilter'

const PlansMain = () => {
  const filter = useFilter()

  const {
    perPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
  } = usePagination(20)

  const { response, isLoading } = useFetch(
    service.recurrence.plans.get,
    { perPage, page, ...{ plan: { ...filter.filters } } },
    [page, perPage, filter.filters],
  )

  return (
    <Container>
      <ContentHeader title="Planos" subtitle="Listagem">
        <Permitted tag="create_plan">
          <Button
            component={Link}
            to={routes.plans.new}
            variant="contained"
            color="primary"
          >
            Criar
          </Button>
        </Permitted>
      </ContentHeader>
      <Paper>
        <TableHeader setDrawerOpen={filter.setDrawerOpen} />
        <PerfectScrollbar>
          <PlansTable
            plans={response && response.data.plans}
            isLoading={isLoading}
          />
        </PerfectScrollbar>
        <Box px={2} display="flex" justifyContent="flex-end">
          {response ? (
            <TablePagination
              component="div"
              count={response.data.meta.totalCount}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
              labelRowsPerPage="Por página"
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          ) : (
            <Box py="11px">
              <Skeleton variant="rect" width={200} height={30} />
            </Box>
          )}
        </Box>
      </Paper>

      <Filters filter={filter}>
        <input label="Identificador" textfieldinput="true" name="id" />
        <input label="Código" textfieldinput="true" name="code" />
        <input label="Nome" textfieldinput="true" name="name" />
        <input currencyinput="true" label="Valor Inicial" name="price_gt" />
        <input currencyinput="true" label="Valor Final" name="price_lt" />
        <select label="Status" textfieldinput="true" name="active">
          <option value=""></option>
          <option value="true">Ativo</option>
          <option value="false">Inativo</option>
        </select>
      </Filters>
    </Container>
  )
}

export default PlansMain
